module.exports = __webpack_public_path__ + "assets/instagramIcon-758d0d.svg";